import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/utils/query-keys';
import { CompanyService } from '@/infra/services/company';
import type { SelectOption } from '@/components/ui/SelectOptions/types';

interface GetCompaniesParams {
	organization_id: string;
}

const Service = CompanyService.getInstance();

export const useGetCompanies = (params: GetCompaniesParams) => {
	return useQuery<SelectOption[]>({
		queryKey: [QUERY_KEYS.GET_COMPANIES, params],
		queryFn: async () => Service.getCompanies(params),
		enabled: !!params.organization_id
	});
};
